/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[ubi-dialog-content][_ngcontent-%COMP%]{font-size:.8rem;letter-spacing:.05em;white-space:pre-wrap}[ubi-dialog-action][_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between}.dialog-button[_ngcontent-%COMP%]{max-width:unset}\n/*# sourceMappingURL=dialog.component.css.map*/"];
export { styles as styles };
